import React, { useState } from "react";
import Icon from "./Icon";
import favicon32 from "../favicon-32.png";

export default function Sidebar({
  activeView,
  setActiveView,
  onLogout,
  onOpenDemoConsole,
  isMobileOpen,
  onCloseMobile,
  nav,
  isAdminPath,
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const defaultNav = [
    { id: "tickets", label: "Tickets", icon: "ticket" },
    { id: "cmdb", label: "CMDB", icon: "database" },
    { id: "network", label: "Network Infrastructure", icon: "network" },
    { id: "knowledge", label: "Knowledge Base", icon: "book" },
  ];
  const navItems = nav || defaultNav;

  return (
    <aside
      className={`sidebar-container ${isCollapsed ? "collapsed" : ""} ${isMobileOpen ? "mobile-open" : ""}`}
      style={{
        minHeight: "100vh",
        background: "#fff",
        borderRight: "1px solid #E5E7EB",
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
      }}
    >
      <div
        className="sidebar-header"
        style={{
          padding: "18px 16px 14px",
          borderBottom: "1px solid #F3F4F6",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 9,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
          <img
            src={favicon32}
            alt="AIOps"
            style={{
              width: 30,
              height: 30,
              borderRadius: 7,
              flexShrink: 0,
              objectFit: "contain",
            }}
          />
          <div>
            <div style={{ fontWeight: 700, fontSize: 13, color: "#111827" }}>
              AIOps
            </div>
            {isAdminPath && (
              <div
                style={{
                  fontSize: 9,
                  fontWeight: 700,
                  color: "#1D4ED8",
                  background: "#EFF6FF",
                  padding: "1px 5px",
                  borderRadius: 4,
                  marginTop: 1,
                  display: "inline-block",
                }}
              >
                ADMIN
              </div>
            )}
          </div>
        </div>

        {/* Toggle Button for Desktop */}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="sidebar-toggle-btn"
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
            borderRadius: 4,
            color: "#6B7280",
          }}
        >
          <Icon name={isCollapsed ? "chevronRight" : "chevronLeft"} size={16} />
        </button>

        {/* Close Button for Mobile Drawer */}
        <button
          onClick={onCloseMobile}
          className="sidebar-mobile-close-btn"
          title="Close menu"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "none", // Overridden by media queries
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
            borderRadius: 4,
            color: "#6B7280",
          }}
        >
          <Icon name="x" size={16} />
        </button>
      </div>

      <nav style={{ padding: "10px 8px", flex: 1 }}>
        <div
          className="sidebar-nav-title"
          style={{
            fontSize: 9,
            fontWeight: 700,
            color: "#9CA3AF",
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            padding: "4px 10px 8px",
            transition: "opacity 0.2s ease",
          }}
        >
          {isAdminPath ? "Admin Tools" : "Navigation"}
        </div>
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => {
              setActiveView(item.id);
              if (onCloseMobile) onCloseMobile();
            }}
            className="sidebar-nav-button"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 9,
              width: "100%",
              padding: "8px 10px",
              borderRadius: 7,
              border: "none",
              cursor: "pointer",
              background: activeView === item.id ? "#EFF6FF" : "transparent",
              color: activeView === item.id ? "#1D4ED8" : "#374151",
              fontSize: 13,
              fontWeight: activeView === item.id ? 600 : 400,
              transition: "all 0.12s",
              textAlign: "left",
              marginBottom: 1,
            }}
          >
            <Icon
              name={item.icon}
              size={15}
              color={activeView === item.id ? "#1D4ED8" : "#6B7280"}
            />
            <span className="sidebar-label">{item.label}</span>
          </button>
        ))}
      </nav>

      <div
        className="sidebar-footer"
        style={{ padding: "10px 14px", borderTop: "1px solid #F3F4F6" }}
      >
        {isAdminPath && onOpenDemoConsole && (
          <button
            onClick={onOpenDemoConsole}
            className="sidebar-demo-button"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              width: "100%",
              padding: "8px 10px",
              borderRadius: 6,
              border: "1px solid #C7D2FE",
              background: "#EEF2FF",
              color: "#4338CA",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              textAlign: "left",
              marginBottom: 8,
            }}
          >
            <Icon name="sliders" size={14} color="#4338CA" />
            <span className="sidebar-label">Fault Injector</span>
          </button>
        )}
        <button
          onClick={onLogout}
          className="sidebar-logout-button"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            width: "100%",
            padding: "8px 0",
            border: "none",
            background: "transparent",
            color: "#4B5563",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            textAlign: "left",
            marginBottom: 4,
          }}
        >
          <Icon name="logOut" size={14} color="#6B7280" />
          <span className="sidebar-label">Logout</span>
        </button>
      </div>
    </aside>
  );
}
